import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { ProductEnum } from '../authentication/models/product.enum';
import { AuthenticationService } from '../authentication/services/authentication.service';
export const autoSplitAccessGuard: CanActivateFn = () =>
  inject(AuthenticationService)
    .getProfileState()
    ?.productIds?.includes(ProductEnum.Payment) ||
  inject(Router).createUrlTree(['/wallet']);
